
import React from 'react';

interface CoachingCalendarProps {
  showCalendar: boolean;
  calendlyRef: React.RefObject<HTMLDivElement>;
  calendlyUrl?: string;
}

const CoachingCalendar = ({ 
  showCalendar, 
  calendlyRef, 
  calendlyUrl = "https://calendly.com/reachpriyaa/mock-ml-interview" 
}: CoachingCalendarProps) => {
  if (!showCalendar) {
    return (
      <div className="bg-muted p-8 rounded-lg h-full flex items-center justify-center">
        <p className="text-center text-muted-foreground">
          The calendar will be available after you click "Book Now".
        </p>
      </div>
    );
  }

  return (
    <div 
      className="calendly-inline-widget" 
      ref={calendlyRef}
      data-url={calendlyUrl}
      style={{ minWidth: '320px', height: '630px' }}
    />
  );
};

export default CoachingCalendar;
